import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { statisticsRoutes } from "./statistics.routing";
import { ApiModule } from "./api/api.module";
import { RootComponent } from "./root.component";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { TranslocoModule } from "@ngneat/transloco";
import { NgApexchartsModule } from "ng-apexcharts";
import { MobileSummaryComponent } from "./mobile/summary.component";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatOptionModule } from "@angular/material/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { InstallationHistoryComponent } from "./mobile/installation-history.component";
import { MauHistoryComponent } from "./mobile/mau-history.component";
import { InactiveTenantsComponent } from "./session/inactive-tenants.component";
import { ToolbarComponent } from "./toolbar.component";
import { ApiCommonModule, TenantServiceProxy } from "@api";
import { AppointmentSummaryComponent } from "./appointments/summary.component";
import { DocumentsSummaryComponent } from "./documents/summary.component";
import { PrescriptionHistoryComponent } from "./documents/prescription-history.component";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { DateRangePickerModule } from "./range-picker/date-range-picker.module";
import { StatsService } from "./services/stats.service";

@NgModule({
    declarations: [
        RootComponent,
        ToolbarComponent,

        AppointmentSummaryComponent,
        MobileSummaryComponent,
        InstallationHistoryComponent,
        MauHistoryComponent,
        InactiveTenantsComponent,

        DocumentsSummaryComponent,
        PrescriptionHistoryComponent
    ],
    imports: [
        RouterModule.forChild(statisticsRoutes),
        CommonModule,
        FormsModule,

        DateRangePickerModule,
        
        ReactiveFormsModule,
        HttpClientModule,
        ApiModule,
        MatButtonModule,
        MatMenuModule,
        MatIconModule,
        MatFormFieldModule,
        MatOptionModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        NgxMatSelectSearchModule,
        MatTooltipModule,
        TranslocoModule,
        NgApexchartsModule,
        MatProgressBarModule,
        ApiCommonModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
    ],
    providers: [
        TenantServiceProxy,
        StatsService
    ]
})
export class StatisticsModule {
}
